(function () {
  'use strict';
  if (customElements.get('park-pdp-routine')) return;
  class ParkPDPRoutine extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = {signal: this.abort.signal};
      this.templates = new Map(); const products = {};
      this.querySelectorAll('[data-product-template]').forEach(template => {
        const id = template.dataset.productId;
        if (this.templates.has(id)) return;
        this.templates.set(id, template);
        products[id] = {id, order: Number(template.dataset.order), defaultVariant: template.dataset.defaultVariant, requiresPlan: template.dataset.requiresPlan === 'true', variants: [...template.content.querySelectorAll('option[data-price]')].map(option => ({id: option.value, title: option.dataset.title, price: Number(option.dataset.price), available: option.dataset.available === 'true', min: Number(option.dataset.min), max: Number(option.dataset.max) || null, increment: Number(option.dataset.increment)}))};
      });
      this.config = {
        products,
        cartProducts: (this.dataset.cartProducts || '').split(',').filter(Boolean),
        hair: [...this.querySelectorAll('[data-hair]')].map(el => ({key:el.dataset.hair, base:el.dataset.base.split(',').filter(Boolean)})),
        goals: [...this.querySelectorAll('[data-goal]')].map(el => ({key:el.dataset.goal, product:el.dataset.recommendProduct, copy:el.dataset.copy, copyWidth:Number(el.dataset.copyWidth) || 0})),
        rules: [...this.querySelectorAll('[data-rule]')].map(el => ({hair:el.dataset.hairKey, goal:el.dataset.goalKey, product:el.dataset.product, copy:el.dataset.copy, copyWidth:Number(el.dataset.copyWidth) || 0}))
      };
      this.state = new window.ParkPDPRoutineState.Routine(this.config);
      this.money = new Intl.NumberFormat(this.dataset.locale || document.documentElement.lang, {style:'currency', currency:this.dataset.currency});
      this.addEventListener('click', event => this.click(event), options);
      this.addEventListener('change', event => this.change(event), options);
      document.addEventListener('shopify:block:select', event => {
        const block = [...this.querySelectorAll('[data-block-id]')].find(el => el.dataset.blockId === event.detail?.blockId);
        if (!block) return;
        this.state.stage = block.hasAttribute('data-hair') ? 'hair' : 'goal';
        this.render();
      }, options);
      this.render(false);
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
    $(selector) { return this.querySelector(selector); }
    async click(event) {
      const target = event.target.closest('button'); if (!target || !this.contains(target) || this.busy) return;
      if (target.hasAttribute('data-hair')) { this.state.reset(); this.state.chooseHair(target.dataset.hair); }
      else if (target.hasAttribute('data-goal')) {
        this.state.extras = [];
        this.state.chooseGoal(target.dataset.goal);
        if (!this.state.accept()) this.state.skip();
      }
      else {
        switch(target.dataset.action) {
          case 'start': if(this.hasAttribute('data-hairtest-popup')){this.dispatchEvent(new CustomEvent('park:hairtest-open',{bubbles:true}));return;} this.state.stage = this.savedStage || 'hair'; break;
          case 'close': this.savedStage = this.state.stage; this.state.stage = 'intro'; break;
          case 'back': this.state.back(); break;
          case 'reset': this.state.reset(); this.savedStage = null; this.state.stage = 'hair'; break;
          case 'skip': this.state.goal = null; this.state.extras = []; this.state.skip(); break;
          case 'accept': this.state.accept(); break;
          case 'another': this.state.stage = 'goal'; break;
          case 'cart': await this.addToCart(target); return;
          default: return;
        }
      }
      this.$('[data-status]').textContent = '';
      this.render();
      if (target.dataset.action === 'close') this.$('[data-action="start"]').focus({preventScroll:true});
    }
    change(event) {
      const card = event.target.closest('[data-product-id]'); if (!card || this.busy) return;
      if (event.target.matches('[data-variant]')) this.state.setVariant(card.dataset.productId,event.target.value);
      if (event.target.matches('[data-include]')) this.state.toggle(card.dataset.productId,event.target.checked);
      this.updateCard(card);
      this.updateTotal();
    }
    card(id, recommendation=false) {
      const template = this.templates.get(id); if (!template) return null;
      const card = template.content.firstElementChild.cloneNode(true);
      card.querySelector('[data-include]').closest('label').hidden = recommendation;
      this.updateCard(card);
      const match = this.config.rules.find(x => x.hair === this.state.hair && x.goal === this.state.goal && x.product === id) || this.config.goals.find(x => x.key === this.state.goal && x.product === id);
      if (match?.copy) {
        const reason = card.querySelector('[data-product-reason]');
        reason.textContent = match.copy;
        if (match.copyWidth > 0) reason.style.maxWidth = `min(100%, ${match.copyWidth}px)`;
      }
      return card;
    }
    updateCard(card) {
      const id = card.dataset.productId; const p = this.config.products[id];
      const selected = p.variants.find(v => v.id === this.state.variants[id]);
      const select = card.querySelector('[data-variant]'); select.value = selected?.id || '';
      Array.from(select.options).forEach(option => {
        const variant = p.variants.find(item => item.id === option.value);
        if (variant) option.textContent = `${variant.title} · ${this.money.format(variant.price / 100)}${variant.available ? '' : ` · ${this.dataset.soldOutLabel}`}`;
      });
      select.disabled = !this.state.available(id);
      card.querySelector('[data-include]').checked = Boolean(this.state.included[id]);
      card.querySelector('[data-include]').disabled = !this.state.available(id);
      card.querySelector('[data-unavailable]').hidden = this.state.available(id);
      card.querySelector('[data-product-price]').textContent = selected ? this.money.format(selected.price / 100) : '';
      const quantityNote = card.querySelector('[data-quantity-note]'); quantityNote.hidden = !selected || selected.min <= 1;
      quantityNote.textContent = selected?.min > 1 ? this.dataset.quantityLabel.replace('__COUNT__',selected.min) : '';
    }
    updateTotal() {
      const cart = this.state.cart();
      this.$('[data-total]').textContent = cart.ready || !cart.items.length && !this.state.entries().some(x=>x.included) ? this.money.format(cart.total/100) : this.dataset.chooseLabel;
      this.$('[data-action="cart"]').disabled = !cart.ready || this.busy;
      this.$('[data-choice-required]').hidden = cart.ready;
    }
    render(focus=true) {
      const stage = this.state.stage; this.dataset.activeStage = stage;
      this.querySelectorAll('[data-stage]').forEach(el => {el.hidden = el.dataset.stage !== stage;});
      this.$('[data-guide]').hidden = stage === 'intro';
      this.$('[data-action="start"]').setAttribute('aria-expanded',String(stage !== 'intro'));
      this.$('[data-action="back"]').hidden = stage === 'hair';
      const current = stage === 'recommend' ? 'result' : stage;
      this.querySelectorAll('[data-progress]').forEach(el => {
        if (el.dataset.progress === current) el.setAttribute('aria-current','step'); else el.removeAttribute('aria-current');
      });
      this.querySelectorAll('[data-hair]').forEach(el => el.setAttribute('aria-pressed',String(el.dataset.hair === this.state.hair)));
      this.querySelectorAll('[data-goal]').forEach(el => el.setAttribute('aria-pressed',String(el.dataset.goal === this.state.goal)));
      this.querySelectorAll('[data-goal]').forEach(el => {
        const rule = this.config.rules.find(x => x.hair === this.state.hair && x.goal === el.dataset.goal);
        el.hidden = !this.state.available(rule?.product || el.dataset.recommendProduct);
      });
      if (stage === 'recommend') {
        const id = this.state.recommended(); const card = this.card(id,true);
        this.$('[data-recommendation]').replaceChildren(...(card ? [card] : []));
        this.$('[data-no-recommendation]').hidden = Boolean(card);
        this.$('[data-action="accept"]').disabled = !this.state.available(id);
        const match = this.config.rules.find(x=>x.hair===this.state.hair && x.goal===this.state.goal) || this.config.goals.find(x=>x.key===this.state.goal);
        this.$('[data-recommend-copy]').textContent = match?.copy || '';
        this.$('[data-recommend-copy]').style.maxWidth = match?.copyWidth > 0 ? `min(100%, ${match.copyWidth}px)` : '';
      }
      if (stage === 'result') {
        const hair = this.querySelector(`[data-hair="${this.state.hair}"]`);
        const goal = this.querySelector(`[data-goal="${this.state.goal}"]`);
        this.$('[data-selection-summary]').textContent = [hair?.textContent.trim(),goal?.textContent.trim()].filter(Boolean).join(' · ');
        this.$('[data-results]').replaceChildren(...this.state.entries().map(({product})=>this.card(product.id)).filter(Boolean));
        this.updateTotal();
      }
      if (focus) {
        const heading = this.$(`[data-stage="${stage}"] h3`);
        heading?.focus({preventScroll:true});
        if (heading && (heading.getBoundingClientRect().top < 100 || heading.getBoundingClientRect().top > innerHeight * .7)) heading.scrollIntoView({block:'center', behavior:'instant'});
      }
    }
    async addToCart(button) {
      const cart = this.state.cart(); if (!cart.ready || this.busy) return;
      this.busy = true;
      const controls = [...this.querySelectorAll('button,input,select')].map(el=>[el,el.disabled]);
      controls.forEach(([el])=>{el.disabled=true;}); this.setAttribute('aria-busy','true');
      const status = this.$('[data-status]');
      try {
        if (!window.ParkPDPCart?.add) throw new Error(this.dataset.errorLabel);
        await window.ParkPDPCart.add(cart.items,{button,status});
      } catch(error) { status.textContent = error.message || this.dataset.errorLabel; }
      finally {
        this.busy = false; this.removeAttribute('aria-busy');
        controls.forEach(([el,disabled])=>{el.disabled=disabled;}); this.updateTotal();
      }
    }
  }
  customElements.define('park-pdp-routine',ParkPDPRoutine);
})();
